import { render, staticRenderFns } from "./card-mask.component.vue?vue&type=template&id=68881fda&scoped=true"
import script from "./card-mask.component.vue?vue&type=script&lang=js"
export * from "./card-mask.component.vue?vue&type=script&lang=js"
import style0 from "./card-mask.component.vue?vue&type=style&index=0&id=68881fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68881fda",
  null
  
)

export default component.exports